if (!customElements.get('bz-subscription')) {
  customElements.define('bz-subscription', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.closest('form') || (this.dataset.form ? document.getElementById(this.dataset.form) : null);
      this.field = this.querySelector('[data-selling-plan]');
      const json = this.querySelector('[data-bz-sub-variants]');
      try {
        this.variants = JSON.parse(json?.textContent || '');
      } catch (e) {
        this.variants = null;
      }
      this._change = (e) => {
        const t = e.target;
        if (!t.matches) return;
        if (t.matches('[data-plan-radio]')) {
          const sub = this.querySelector('[data-sub-radio][value="subscribe"]');
          if (sub) sub.checked = true;
        }
        if (t.matches('[data-sub-radio], [data-plan-radio]')) this.sync();
      };
      this._form = (e) => {
        if (e.target.name === 'id') this.onVariant();
      };
      this.addEventListener('change', this._change);
      this.form?.addEventListener('change', this._form);
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._change);
      this.form?.removeEventListener('change', this._form);
      this.bound = false;
    }

    variantData() {
      const id = this.form?.querySelector('[name="id"]')?.value;
      if (!this.variants || !id || !Object.prototype.hasOwnProperty.call(this.variants, id)) return null;
      return this.variants[id];
    }

    onVariant() {
      const data = this.variantData();
      if (!data) return;
      const list = this.querySelector('[data-sub-plans]');
      const tpl = this.querySelector('[data-plan-template]');
      const prev = this.querySelector('[data-plan-radio]:checked')?.value;
      const per = this.dataset.perItem;
      list.replaceChildren();
      (data.plans || []).forEach((plan, i) => {
        const row = tpl.content.firstElementChild.cloneNode(true);
        const radio = row.querySelector('[data-plan-radio]');
        radio.value = plan.id;
        radio.name = this.dataset.planName;
        radio.setAttribute('form', this.dataset.detach);
        radio.checked = prev ? String(plan.id) === String(prev) : i === 0;
        row.querySelector('[data-plan-name]').textContent = plan.name || '';
        row.querySelector('[data-plan-price]').textContent = plan.price || '';
        const unit = row.querySelector('[data-plan-unit]');
        if (plan.unit) {
          unit.hidden = false;
          unit.textContent = per ? '(' + plan.unit + ' ' + per + ')' : '(' + plan.unit + ')';
        }
        const off = row.querySelector('[data-plan-off]');
        if (plan.percent > 0) {
          off.hidden = false;
          off.textContent = '-' + plan.percent + '%';
        }
        list.appendChild(row);
      });
      const price = this.querySelector('[data-onetime-price]');
      const compare = this.querySelector('[data-onetime-compare]');
      if (price) price.textContent = data.price || '';
      if (compare) {
        compare.hidden = !data.compare;
        compare.textContent = data.compare || '';
      }
      const has = (data.plans || []).length > 0;
      const wrap = this.querySelector('[data-sub-plan]');
      if (wrap) wrap.hidden = !has;
      if (!has) {
        const once = this.querySelector('[data-sub-radio][value="onetime"]');
        if (once) once.checked = true;
      }
      this.sync();
    }

    sync() {
      const data = this.variantData();
      const plans = data ? (data.plans || []) : [];
      const once = this.querySelector('[data-sub-radio][value="onetime"]');
      let mode = this.querySelector('[data-sub-radio]:checked')?.value || 'subscribe';
      if (this.dataset.requires === 'true' || !once) mode = 'subscribe';
      if (!plans.length && once) mode = 'onetime';
      const checked = this.querySelector('[data-plan-radio]:checked');
      const plan = plans.find((p) => String(p.id) === String(checked?.value)) || plans[0] || null;
      const submit = mode === 'subscribe' && plan ? String(plan.id) : '';
      if (this.field && (this.field.value !== submit || this.field.disabled !== (submit === ''))) {
        this.field.value = submit;
        this.field.disabled = submit === '';
      }
      const list = this.querySelector('[data-sub-plans]');
      const showPlans = mode === 'subscribe' && plans.length > 0;
      if (list) list.hidden = !showPlans;
      const terms = this.querySelector('[data-sub-terms]');
      if (terms) terms.hidden = mode !== 'subscribe';
      this.querySelectorAll('[data-plan-radio]').forEach((radio) => {
        radio.disabled = mode !== 'subscribe';
        radio.closest('.bz_sub_row')?.classList.toggle('is-selected', mode === 'subscribe' && radio.checked);
      });
      const save = this.querySelector('[data-sub-save]');
      if (save) {
        const show = mode === 'subscribe' && plan && plan.percent > 0;
        save.hidden = !show;
        if (show) save.textContent = '-' + plan.percent + '%';
      }
      const group = this.querySelector('[data-sub-group]');
      if (group) {
        const name = mode === 'subscribe' && plan ? (plan.group || '') : '';
        const show = !!name && name.trim().toLowerCase() !== (this.dataset.subscribeLabel || '').trim().toLowerCase();
        group.hidden = !show;
        if (show) group.textContent = name;
      }
      const note = this.querySelector('[data-sub-note]');
      if (note) {
        const text = mode === 'subscribe' && plan ? (plan.description || plan.options || '') : '';
        note.hidden = !text;
        note.textContent = text;
      }
      this.querySelector('[data-sub-plan]')?.classList.toggle('is-selected', mode === 'subscribe');
      this.querySelector('[data-sub-onetime]')?.classList.toggle('is-selected', mode === 'onetime');
      window.BzA11y?.makeContentFocusable(this);
    }
  });
}
